// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btndel[data-v-553807f2]{position:absolute;z-index:1;width:20px !important;height:20px !important;left:43px;top:1px}.pictrue[data-v-553807f2]{width:60px;height:60px;border:1px dotted rgba(0,0,0,.1);margin-right:10px;position:relative;cursor:pointer}.pictrue img[data-v-553807f2]{width:100%;height:100%}[data-v-553807f2] .el-dialog__close{position:absolute;top:15px;right:15px}[data-v-553807f2] .el-dialog__header{border-bottom:none;padding:0 !important}", ""]);
// Exports
module.exports = exports;
